export default {
  mounted() {
    const subtitle = (this as { windowSubTitle?: string }).windowSubTitle || "";
    document.title = (subtitle ? subtitle + " | " : "") + "号外ネット広告管理";
  }
};
